import { DateTime } from 'luxon';

// Get taskInfo safely
export function getTaskInfo(ev) {
  return ev.taskInfo || {};
}

export function formatTimestampISOToBrussels(iso) {
  if (!iso) return '';
  return DateTime.fromISO(iso, { zone: 'utc' }).setZone('Europe/Brussels').toFormat('yyyy-LL-dd HH:mm:ss');
}

export function getTaskType(ev) {
  return ev.taskType || (getTaskInfo(ev).type) || '';
}

export function getQueue(ev) {
  const ti = getTaskInfo(ev);
  return ti.taskQueue || 'NVT';
}

export function getDirection(ev) {
  const type = getTaskType(ev);
  const ti = getTaskInfo(ev);
  if (type === 'meccatask' || type === 'voice') {
    return (ti.attributes && ti.attributes.direction) || '';
  }
  return '';
}

export function getFrom(ev) {
  const type = getTaskType(ev);
  const ti = getTaskInfo(ev);
  if (type === 'meccatask' || type === 'voice') {
    return (ti.attributes && ti.attributes.from) || '';
  }
  return (ti.customer) || '';
}

export function getTo(ev) {
  const type = getTaskType(ev);
  const ti = getTaskInfo(ev);
  if (type === 'meccatask' || type === 'voice') {
    if (ti.attributes && ti.attributes.direction === 'outbound') {
      return (ti.attributes.outbound_to) || '';
    }
    return (ti.attributes && ti.attributes.to) || '';
  }
  return (ti.customer) || '';
}

// Original description logic used for filter matching
export function buildFilterDescription(ev) {
  const ti = getTaskInfo(ev);
  if (ev.eventType === 'worker.activity.update') {
    return `${ev.worker} updated from ${ev.previousActivity || 'Unknown'} to ${ev.currentActivity}`;
  } else if (ti.type === 'voice') {
    return `${ti.attributes?.direction || ''} call: ${ti.attributes?.from || ''} ${ti.customer || ''}`.trim();
  } else if (ti.type === 'meccatask') {
    let desc = '';
    if (ev.eventType === 'task.created') desc = 'Mecca task created';
    else if (ev.eventType === 'reservation.created') desc = 'Mecca task offered';
    else if (ev.eventType === 'reservation.accepted') desc = 'Mecca task accepted';
    else if (ev.eventType === 'reservation.completed') desc = 'Mecca task completed';
    if (ti.attributes?.customerId) desc += ` ${ti.attributes.customerId}`;
    return desc.trim();
  } else if (ti.type === 'administration') {
    let desc = '';
    if (ev.eventType === 'task.created' || ev.eventType === 'reservation.created') desc = 'customerFile opened';
    else if (ev.eventType === 'task.completed') desc = 'customerFile closed';
    if (ti.attributes?.customerId) desc += ` ${ti.attributes.customerId}`;
    return desc.trim();
  }
  return ev.description || '';
}

export function passesFilters(ev, filters) {
  // Administration event visibility rule
  const ti = getTaskInfo(ev);
  if (ti && ti.type === 'administration') {
    if (!(ev.eventType === 'reservation.created' || ev.eventType === 'task.completed')) return false;
  }
  if (filters.sid) {
    const sid = ti && (ti.taskSid || ti.sid);
    if (!sid || !sid.toLowerCase().includes(filters.sid.toLowerCase())) return false;
  }
  if (filters.timestamp) {
    const ts = formatTimestampISOToBrussels(ev.timestamp);
    if (!ts.toLowerCase().includes(filters.timestamp.toLowerCase())) return false;
  }
  if (filters.eventType && !(ev.eventType || '').toLowerCase().includes(filters.eventType.toLowerCase())) return false;
  if (filters.worker && !(ev.worker || '').toLowerCase().includes(filters.worker.toLowerCase())) return false;
  if (filters.description) {
    const desc = buildFilterDescription(ev);
    if (!desc.toLowerCase().includes(filters.description.toLowerCase())) return false;
  }
  if (filters.type && !getTaskType(ev).toLowerCase().includes(filters.type.toLowerCase())) return false;
  if (filters.queue) {
    const queue = getTaskInfo(ev).taskQueue;
    if (!queue || !queue.toLowerCase().includes(filters.queue.toLowerCase())) return false;
  }
  if (filters.direction) {
    const dir = getDirection(ev);
    if (!dir.toLowerCase().includes(filters.direction.toLowerCase())) return false;
  }
  if (filters.from) {
    const from = getFrom(ev);
    if (!from.toLowerCase().includes(filters.from.toLowerCase())) return false;
  }
  if (filters.to) {
    const to = getTo(ev);
    if (!to.toLowerCase().includes(filters.to.toLowerCase())) return false;
  }
  return true;
}

export function getRowBackground(eventType) {
  switch (eventType) {
    case 'task.created':
      return '#ffe5ec';
    case 'reservation.created':
      return '#e0f7fa';
    case 'reservation.accepted':
      return '#e6f4ea';
    case 'reservation.completed':
    case 'task.completed':
      return '#fff9e5';
    case 'worker.activity.update':
      return '#e5e9ff';
    default:
      return '#f5f5f5';
  }
}
